// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import Modal from '../common/modal';
import Indication from '../ui/indication.js';
import LoadingIndicator from '../ui/loading-indicator.js';
import Icon from '../icon/icon.js';
import StripeContainer from './stripe.container.js';
import StripeFields from './card-create.block.js';
import { addCard } from './card.actions.js';
import { ADD_CARD } from './card.const.js';
import { selectUIModal, selectUIMessages, selectUIProgress } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import type { Messages } from '../ui/ui.types.js';

type Props = {|
  messages: Messages,
  progress: boolean,
  addCardModal: boolean,
  widthIcon?: boolean,
  addCard: typeof addCard,
  setModal: typeof setModal
|};

class AddCardBtn extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onAddCardOpen = this.onAddCardToggle.bind(this, true);
    this.onAddCardClose = this.onAddCardToggle.bind(this, false);

    this.onAddCard = this.onAddCard.bind(this);
  }

  onAddCardOpen: Function;
  onAddCardClose: Function;

  onAddCardToggle(state: boolean) {
    this.props.setModal(state, ADD_CARD);
    return true;
  }

  onAddCard(stripe, cardElement) {
    return this.props.addCard(stripe, cardElement);
  }

  render() {
    const { messages, progress, addCardModal, widthIcon = false } = this.props;

    return (
      <React.Fragment>
        <Indication closable messages={messages} className="message-indicator" />

        <Modal
          isOpen={addCardModal}
          className="row smart-dialog-modern"
          header={<div className="smart-dialog-header">Add a credit card</div>}
          footer={
            <div className="col-md-12 buttons">
              <label disabled={progress} htmlFor="stripe-add-card" className="btn btn-success">
                Add card
              </label>

              {progress ? <LoadingIndicator /> : null}
            </div>
          }
          onClose={this.onAddCardClose}
        >
          <StripeContainer>
            <StripeFields handleSubmit={this.onAddCard} submitId="stripe-add-card" />
          </StripeContainer>
        </Modal>
        <div>
          <button
            className={widthIcon ? 'btn-width-plus' : 'btn btn-xs btn-success btn-add-card'}
            onClick={this.onAddCardOpen}
            disabled={progress}
          >
            {widthIcon ? (
              <Icon
                className="btn-width-plus-icon"
                width="15px"
                height="15px"
                name="plus-circled"
              />
            ) : null}
            <span className={widthIcon ? 'btn-width-plus-text' : ''}>Add a New Card</span>
          </button>
        </div>
      </React.Fragment>
    );
  }
}

const messagesSelector = selectUIMessages();
const progressSelector = selectUIProgress(ADD_CARD);
const addCardModalSelector = selectUIModal(ADD_CARD);

const mapStateToProps = state => ({
  messages: messagesSelector(state),
  progress: progressSelector(state),
  addCardModal: addCardModalSelector(state)
});

export default connect(
  mapStateToProps,
  {
    setModal,
    addCard
  }
)(AddCardBtn);
